var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic-asset-association-container"},[(_vm.currentTopic)?[_c('topic',{attrs:{"subtopic":_vm.currentSubtopic,"topic":_vm.currentTopic},on:{"accordion-toggled":_vm.handleAccordionToggle}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }